import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { SearchForm } from '@occc/ui-design-system';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';

import { RetailerNetworkListPage } from './retailer-network-list-page.component';

import { useGetRetailerNetworksForUserQueryPaginated } from '../../data-access/queries';
import { routeCreator } from '../retailer-connect.utils';

type RetailerNetworkListPageContainerProps = {
  redirectTo?: 'overview' | 'performance' | 'myStores' | 'tobacco';
  pageSubtitle?: string;
};

export const RetailerNetworkListPageContainer = ({
  redirectTo,
  pageSubtitle,
}: RetailerNetworkListPageContainerProps) => {
  const navigate = useNavigate();
  const [search, setSearch] = useSearchParams();
  const [paginationInfo, onPageChange] = usePaginationParams();

  const { loading, error, data, paginationProps } = useGetRetailerNetworksForUserQueryPaginated({
    filter: {
      search,
    },
    paginationInfo,
    onPageChange,
  });

  const tableActions = useMemo(
    () => (
      <SearchForm
        onSubmit={(values) => {
          setSearch(values.search);
        }}
        initialValues={{ search }}
      />
    ),
    [search, setSearch],
  );

  const networkClick = useCallback(
    (uuid: string) => {
      if (redirectTo) {
        navigate(routeCreator[redirectTo](uuid));
        return;
      }
      navigate(routeCreator.overview(uuid));
    },
    [navigate, redirectTo],
  );

  return (
    <RetailerNetworkListPage
      loading={loading}
      error={error}
      data={data}
      paginationProps={paginationProps}
      tableActions={tableActions}
      onNetworkClick={networkClick}
      pageSubtitle={pageSubtitle}
    />
  );
};
